import React, { useState, useEffect } from "react";
import { Grid, Typography } from '@material-ui/core';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from "react-i18next"
import { WebSessionContextProvider } from "@switch/core";
import Api from "../../Api";
import { Redirect } from "./Redirect";
import { ResultProcessor } from "./ResultProcessor";

export function PayResultHandler() {
    let [searchParams] = useSearchParams();
    const [response, SetResponse] = useState();
    let websession = searchParams.get("SID");
    let sessionId = searchParams.get("sessionId");
    let provider = searchParams.get("provider");
    let result = searchParams.get("result");
    const { t, i18n } = useTranslation();


    const [processed, setProcessed] = useState(false);



    const API = new Api(
        {
            urlRoot: window.location.origin + "/Dispace/Switch/1.0.0/",
            widgetKey: websession
        });

    useEffect(() => {
        if (!websession) return;

        switch (provider) {
            case "GovPay":
                const govPayresponse = {
                    source: "payresult",
                    webSessionId: websession,
                    result: result,
                    provider: provider,
                }
                SetResponse(govPayresponse)
                break;
            case "Pay360SCP":
            default:
                const pay360response = {
                    source: "payresult",
                    sessionId: sessionId,
                    result: result,
                    provider: provider,
                }
                SetResponse(pay360response)
        }
        //setProcessed(true)
    }, [result, websession])

    if (!response) return
    return (
        <WebSessionContextProvider dataProvider={API} sessionKey={websession}>
            <Grid container direction="row" justify="center" alignItems="flex-start">
                <Typography>{t("switch.widget.payresult.complete")}</Typography>
                <Redirect processed={processed} />
                <ResultProcessor result={response} onProcessed={setProcessed} />
            </Grid>
        </WebSessionContextProvider>
    )
}